<template>
	<nav>
		<ul>
			<li>
			<type-button @boxCreate="createCollection" :boxCadastro="boxCadastro"
				iconCollection="fas" iconName="folder-plus" title="Criar coleção" :wideIcon="true"
			:createCollection="createCollection" />
		</li>
			<li>
				<router-link :to="{ name: 'home' }"><i class="fas fa-home" /></router-link>
			</li>
			<!--
			<li>
				<router-link :to="{ name: 'home' }" class="alert"><i class="far fa-lightbulb" /></router-link>
			</li>
			-->
			<li>
				<router-link :to="{ name: 'minhasColecoes' }" class="user-name">
					<i class="fas fa-user-circle" />
					<span>{{ $auth.user().nome.split(' ')[0] }}</span>
				</router-link>
			</li>
			<li @click="logout">
				<router-link :to="{ name: 'login' }"><i class="fas fa-sign-out-alt" /></router-link>
			</li>
		</ul>
		<CadastrarColecao @boxCreate="createCollection" :boxCadastro="boxCadastro" v-if="boxCadastro"/>
	</nav>
</template>

<script>
import CadastrarColecao from '@/components/views/colecoes/inc/CadastrarColecao'
import TypeButton from '@/components/shared/TypeButton'
export default {
	name: 'NavBar',
	components: { TypeButton, CadastrarColecao },
	data () {
		return {
			boxCadastro: false
		}
	},
	methods: {
		logout () {
			localStorage.removeItem('repov4-token')
		},
		Cadastro () {
			this.boxCadastro = !this.boxCadastro
		},
		createCollection (boxCreate) {
			this.boxCadastro = typeof boxCreate !== 'undefined'
		}
	}
}
</script>

<style lang="scss" scoped>
	nav {
		padding: 20px 0;

		ul {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			li {
				color: #fff;

				&:not(:last-of-type) {
					margin-right: 20px;
				}

				a {
					text-decoration: none;
					color: inherit;
					font-size: 1.4em;
					transition: .3s ease;

					&.alert {
						background: #fff;
						color: $main-color;
						width: 34px;
						height: 34px;
						border-radius: 100%;
						display: flex;
						justify-content: center;
						align-items: center;

						&:hover {
							background: $main-color;
							color: #fff;
						}
					}

					&.user-name {
						background: #fff;
						color: $main-color;
						padding: 4px 14px;
						border-radius: 20px;
						display: flex;
						justify-content: center;
						align-items: center;

						&:hover {
							background: $main-color;
							color: #fff;
						}

						span {
							font-size: .7em;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}
</style>
